"use client";

import { useEffect, useState } from "react";
import Shimmer from "../Shimmer";
import ShimmerItem from "../Shimmer/ShimmerItem";
import styles from "./CardShimmer.module.scss";

export default function CardShimmer({ count: cardCount =3, direction = "row" }: { count?: number, direction?: string }) {
  const [count, setCount] = useState(cardCount);

  useEffect(() => {
    const updateCount = () => {
      setCount(window.innerWidth < 700 ? 1 : cardCount);
    };
    updateCount();
    window.addEventListener("resize", updateCount);
    return () => window.removeEventListener("resize", updateCount);
  }, []);

  return (
    <Shimmer
      gap="1rem"
      direction={direction as "row" | "column"}
      justify="center"
      align="start"
      className="w-100"
    >
      {Array.from({ length: count }).map((_, idx) => (
        <Shimmer key={idx} className={styles.card}>
          {/* 👇 Card content skeleton */}
          <ShimmerItem
            width="100%"
            height="220px"
            className={`${styles.image} mb-2`}
          />

          {/* Tag */}
          <ShimmerItem width="30%" height="16px" className="mb-1" />

          {/* Title */}
          <ShimmerItem width="80%" height="20px" className="mb-2" />

          {/* Description */}
          <Shimmer gap="0.25rem" direction="column" className="mb-2">
            <ShimmerItem width="90%" height="14px" />
            <ShimmerItem width="85%" height="14px" />
            <ShimmerItem width="70%" height="14px" />
          </Shimmer>

          {/* Date */}
          <ShimmerItem width="40%" height="14px" />
        </Shimmer>
      ))}
    </Shimmer>
  );
}
